import { observer } from 'mobx-react-lite';

import { IcBotIcon } from '@gem/icons';
import { FAB } from '@gem/ui-kit';

import usePresenter from './presenter';

const BotCommandsButton = () => {
  const presenter = usePresenter();

  return (
    <FAB
      size="10"
      Icon={IcBotIcon}
      theme={presenter.isOpened ? '2_1' : '2'}
      onClick={presenter.toggle}
    />
  );
};

export default observer(BotCommandsButton);
